import ApiService from "./ApiService";

/**
 * Service to handle request about users
 */
const MessageService = {
  async startMission(mission: MissionType, userIds: number[], parameters?: Dic<unknown>) {
    return ApiService.post("/messages/mission/start", { targetType: "USER", mission, targetId: userIds, parameters });
  },
  async stopMission(userIds: number[]) {
    return ApiService.post("/messages/mission/stop", { targetType: "USER", targetId: userIds });
  },
  async askStates() {
    return ApiService.post("/messages/states");
  },
  async skipPoints(userId: number, amount: number) {
    return ApiService.post("/messages/mission/skip-point", { userId, amount });
  },
};

export default MessageService;
